import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { useBoundStore } from 'useStore';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import exportProductMasterRequest from '../Services/exportProductMasterRequest';

export default function useExportProductMasterData() {
	const { accessToken, user } = useAuth();

	const isAdmin = user.permissions.includes('ProductViewManage:Admin');
	const isViewer = user.permissions.includes('ProductViewManage:View');

	const mainCountry = useCurrentMasterCountry();
	const mainCountryId = mainCountry?.id;

	const search = useBoundStore((state) => state.productMasterSearch);
	const selectedBrand = useBoundStore(
		(state) => state.productMasterSelectedBrand
	);

	const selectedOwner = useBoundStore(
		(state) => state.productMasterStSelectedOwners
	);

	let userFilter = null;
	if (isViewer && !isAdmin) {
		userFilter = user.name;
	}

	const paginationModel = { page: 0, pageSize: 3000 };

	const exportProductMasterData = useQuery({
		queryKey: [
			'productMasterData',
			mainCountryId,
			selectedBrand,
			search,
			selectedOwner,
			userFilter,
		],
		queryFn: () =>
			exportProductMasterRequest({
				accessToken,
				search,
				mainCountryId,
				selectedOwner,
				selectedBrand,
				paginationModel,
				userFilter,
			}),

		enabled: !!mainCountryId,
		staleTime: Infinity,
		retry: false,
	});

	return exportProductMasterData;
}
